<div class="hidden-layer" [hidden]="!state.gridLoading">
  <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
</div>
<ag-grid-angular
  class="ag-theme-material-datos"
  [gridOptions]="gridOptions"
  [columnDefs]="columnDefs"
  [rowData]="state.rows"
  (gridReady)="gridReady($event)"
  (rowClicked)="onRowClicked($event)"
  (rowDataChanged)="onRowDataChanged($event)"
  [getContextMenuItems]="normalizedGetContextMenuItems"
></ag-grid-angular>
